const mutations = {
}

export default mutations



// WEBPACK FOOTER //
// ./module/passport/src/store/mutations.js